import { useState, useEffect } from "react";

const useLocalStorageState = (stateName, initialState) => {
  // Get the initial state from local storage or use the provided initial state
  const getInitialState = () => {
    const storedState = localStorage.getItem(stateName);
    if (storedState && storedState !== "undefined") {
      try {
        return JSON.parse(storedState);
      } catch (error) {
        // Remove invalid entry from local storage
        localStorage.removeItem(stateName);
        return initialState;
      }
    }
    return initialState;
  };

  // Initialize state with the initial state
  const [state, setState] = useState(() => getInitialState());

  // Update local storage whenever the state changes
  useEffect(() => {
    localStorage.setItem(stateName, JSON.stringify(state));
  }, [state, stateName]);

  return [state, setState];
};

export default useLocalStorageState;
